import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import Alert from './Alert';
import useDraggableModal from '../../hooks/useDraggableModal';

/**
 * Componente de diálogo de confirmación moderno
 * 
 * @param {boolean} isOpen - Si el diálogo está abierto
 * @param {function} onClose - Callback para cancelar
 * @param {function} onConfirm - Callback para confirmar
 * @param {string} title - Título del diálogo
 * @param {string} message - Mensaje de confirmación
 * @param {string} confirmText - Texto del botón confirmar (default: "Confirmar")
 * @param {string} cancelText - Texto del botón cancelar (default: "Cancelar")
 * @param {object} icon - Objeto de icono FontAwesome (default: faTrash)
 * @param {string} type - Tipo de confirmación: 'danger', 'warning', 'info' (default: 'danger')
 * @param {string} successMessage - Mensaje de éxito (opcional)
 * @param {string} errorMessage - Mensaje de error (opcional)
 * @param {function} onSuccessClose - Callback cuando se cierra el mensaje de éxito
 * @param {function} onErrorClose - Callback cuando se cierra el mensaje de error
 * @param {boolean} isProcessing - Estado de carga para deshabilitar acciones
 */
const ConfirmDialog = ({ 
  isOpen, 
  onClose, 
  onConfirm,
  title,
  message,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  icon = faTrash,
  type = 'danger',
  successMessage = '',
  errorMessage = '',
  onSuccessClose,
  onErrorClose,
  isProcessing = false
}) => {
  const { contentRef, dragHandleProps, contentStyle } = useDraggableModal(isOpen);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div ref={contentRef} className={`modal-content modern-modal confirm-dialog`} style={contentStyle} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header" {...dragHandleProps}>
          <div className="modal-header-content">
            <div className="modal-header-icon">
              <FontAwesomeIcon icon={icon} />
            </div>
            <h3>{title}</h3>
          </div>
          <button
            className="close-button"
            onClick={onClose}
            type="button"
          >
            <i className="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>
        <div className="modal-body confirm-body">
          {errorMessage && (
            <Alert 
              type="error"
              message={errorMessage}
              onClose={onErrorClose}
              autoClose={4000}
            />
          )}
          {successMessage && (
            <Alert 
              type="success"
              message={successMessage}
              onClose={onSuccessClose}
              autoClose={3000}
             />
           )}
          <p className="confirm-message">{message}</p>
        </div>
        <div className="confirm-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onClose}
          >
            <i className="fa fa-times" aria-hidden="true"></i> {cancelText}
          </button>
          <button
            type="button"
            className={`btn ${type === 'danger' ? 'btn-danger' : 'btn-primary'}`}
            onClick={onConfirm}
            disabled={isProcessing}
          >
            <i className="fa fa-check" aria-hidden="true"></i> {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;

